function zeropad(n: number, len: number) {
  const s = `${n}`;
  return s.length >= len ? s : ('0'.repeat(len - s.length) + s);
}

export function getFormatDate(dateToFormat: Date | string) {
  const date = new Date(dateToFormat);
  return `${zeropad(date.getFullYear(), 4)}-${zeropad(1 + date.getMonth(), 2)}-${zeropad(date.getDate(), 2)}`;
}

export function getValidDateFromIT(value: string): Date {
  const day = value.substr(0, 2);
  const month = value.substr(3, 2);
  const year = value.substr(6, 4);
  return new Date(`${year}-${month}-${day}`);
}

export function formatDateStrToIT(value: string): string {
  const year = value.substr(0, 4);
  const month = value.substr(5, 2);
  const day = value.substr(8, 2);
  return `${day}/${month}/${year}`;
}
